import { AssetSelectedTypeMap } from '../../../../../../store/product/types';
import { ProductsType } from '../../../DynamicAsset/constants';
import { ResponsiveButton, ResponsiveButtonProps } from '../ResponsiveButton';

export interface AssetButtonProps<T extends keyof AssetSelectedTypeMap>
  extends Omit<
    ResponsiveButtonProps<T>,
    'text' | 'color' | 'icon' | 'mobileIconColor' | 'mobileButtonIconColor'
  > {
  tooltip?: string;
  isSelected: boolean;
}

export const AssetButton = ({ isSelected, ...props }: AssetButtonProps<ProductsType>) => {
  return (
    <ResponsiveButton
      {...props}
      text={isSelected ? 'Remover' : 'Adicionar'}
      color={isSelected ? 'feedback.error.default' : 'brand.tertiary.principal'}
      icon={isSelected ? 'Trash' : 'PlusBigger'}
      mobileIconColor={isSelected ? 'feedback.error.default' : 'neutral.white'}
      mobileButtonIconColor={isSelected ? 'feedback.error.lightest' : undefined}
    />
  );
};
